import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import i18n from 'helper/i18n';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators, getBirthdate, getIsUpdatingAnamnesis } from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { mapParentStateToProps } from '../Anamnesis';

const mapStateToProps = (state: IRootState, props: WithRouterType) => ({
	...mapParentStateToProps(state, props),
	currentStep: ANAMNESIS_VIEWS.DETERMINE_AGE,
	value: getBirthdate(state),
	isUpdatingAnamnesis: getIsUpdatingAnamnesis(state),
	introTitle: i18n('react.impulsCoach.components.anamnesis.determineAge.introTitle'),
	introText: i18n('react.impulsCoach.components.anamnesis.determineAge.introText'),
	title: i18n('react.impulsCoach.components.anamnesis.determineAge.title'),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export type DetermineAgeContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
